/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessageCircle2 = createReactComponent("message-circle-2", "IconMessageCircle2", [
  ["path", { d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1", key: "svg-0" }]
]);

export { IconMessageCircle2 as default };
//# sourceMappingURL=IconMessageCircle2.js.map
